<script>
import Dialog from "element-ui/lib/dialog";

export default {
  name: 'std-dialog',
  extends: Dialog,
  created() {
    this.rendered = true;
  },
};
</script>

